<div class="dialog-container">

  <div class="dialog-header">
    <h2 class="dialog-title">{{ 'permit.manage.status_dialog.title' | translate }}</h2>
    <button type="button" class="close-btn" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">

    <div class="status-chip-row">
      <span class="status-chip"
            [ngStyle]="{
              'background-color': getChipBackground(data.targetStatus.color),
              'color': '#000000'
            }">
        <span class="status-dot" [ngStyle]="{'background-color': data.targetStatus.color}"></span>
        {{ statusName(data.targetStatus.name) }}
      </span>
    </div>

    <div *ngIf="isTerminal" class="terminal-warning">
      <mat-icon class="warning-icon">warning</mat-icon>
      <span>{{ 'permit.manage.status_dialog.terminal_warning' | translate }}</span>
    </div>

    <form [formGroup]="form">

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'permit.manage.status_dialog.reason' | translate }}</mat-label>
        <textarea matInput
                  formControlName="reason"
                  rows="3">
        </textarea>
        <mat-error *ngIf="form.get('reason').hasError('required')">
          {{ 'permit.manage.status_dialog.reason_required' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="isConditional" appearance="outline" class="full-width">
        <mat-label>{{ 'permit.manage.status_dialog.conditions' | translate }}</mat-label>
        <textarea matInput
                  formControlName="conditions"
                  rows="3">
        </textarea>
        <mat-error *ngIf="form.get('conditions').hasError('required')">
          {{ 'permit.manage.status_dialog.conditions_required' | translate }}
        </mat-error>
      </mat-form-field>

    </form>

  </div>

  <div class="dialog-footer">
    <button type="button" mat-stroked-button (click)="cancel()">
      {{ 'permit.manage.status_dialog.cancel' | translate }}
    </button>
    <button type="button" mat-flat-button color="primary" (click)="confirm()">
      {{ 'permit.manage.status_dialog.confirm' | translate }}
    </button>
  </div>

</div>
